import type { Middleware, UnknownAction } from "redux";
import {
    convertMultiStepReaction,
    convertReaction,
    removeMultiStepReaction,
    removeReaction,
    submitMultiStepReactionsEditModal,
    submitReactionsEditModal,
    submitReactionsLoadModal,
} from "../actions/reactions";

const USER_SCOPED_ACTION_TYPES = new Set<string>([
    submitReactionsEditModal.type,
    submitReactionsLoadModal.type,
    removeReaction.type,
    convertReaction.type_success,
    submitMultiStepReactionsEditModal.type,
    removeMultiStepReaction.type,
    convertMultiStepReaction.type_success,
]);

type ActionWithMeta = UnknownAction & {
    meta?: Record<string, unknown>;
};

/** Adds the active Pocketbook user ID to persisted workspace mutations. */
export const userScopedPersistentActionMiddleware: Middleware =
    (api) => (next) => (action) => {
        const typedAction = action as ActionWithMeta;
        if (!USER_SCOPED_ACTION_TYPES.has(typedAction.type)) {
            return next(action);
        }

        const userId = (api.getState() as { user?: { id?: number } }).user?.id;
        if (userId == null) {
            return next(action);
        }

        return next({
            ...typedAction,
            meta: {
                ...(typedAction.meta ?? {}),
                userId,
            },
        });
    };
